import api from './api'

class EnumService {
    async get(type) {
        return api.get('/enum/' + type)
    }
}

export default new EnumService();
